import { Button, IconButton } from '@mui/material';
import React, { useCallback, useState } from 'react'
import EntitySearchDialog from './form/EntitySearch/EntitySearchDialog';
import SearchIcon from "@mui/icons-material/Search";

export default function ButtonSelectEntity({ EntityClass, buttonText, extraQuery, onSelect, label, hideFilterColumns, defaultFilters }) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    // const [searchDialog, setSearchDialog] = useState();

    const loadOptions = useCallback(async () => {

        if (options.length === 0) {

            const result = await EntityClass.getAllQuery(extraQuery);

            setOptions(result);
        }
    }, [EntityClass, extraQuery, options.length]);

    function openSearchDialog() {
        loadOptions();
        // searchDialog.setOpen(true);
        setOpen(true)
    }

    const filteredColumns = EntityClass.searchColumns.filter(column =>
        ['nome', 'status', 'sequencialIndex'].includes(column.field)
    );

    return (
        <>
            {buttonText ?
                <Button variant="outlined" onClick={openSearchDialog} >
                    {buttonText}
                </Button>
                :
                <IconButton onClick={openSearchDialog} sx={{ p: "2px" }}>
                    <SearchIcon />
                </IconButton>}
            {open &&
                <EntitySearchDialog
                    open={open}
                    checkboxselection="true"
                    title={label || "Selecionar"}
                    columns={filteredColumns}
                    data={options}
                    hidefiltercolumns={hideFilterColumns}
                    defaultfilters={defaultFilters}
                    onClose={(value) => {
                        setOpen(false)
                        if (value) {
                            onSelect(value)
                        }
                    }}
                />
            }
        </>
    )
}
